import { authFetch } from "utils/authFetch";
import type { TrayVerdicts } from "./types";

const API_URL =
  process.env.NODE_ENV === "production"
    ? ""
    : (process.env.REACT_APP_BACKEND_URL ?? "http://localhost:5050");

/**
 * Under the ROUTER's own path, because the router is the only thing that reads a
 * verdict. A route type is renamed, merged and LV-matched by features that never
 * route a cable, so whether cable rides one is not addressed as a property of
 * the type.
 */
const ENDPOINT = `${API_URL}/api/quantity-surveyor-cable-routing/tray-verdicts`;

interface TrayVerdictRow {
  routeTypeId: number;
  carriesCable: boolean;
}

/**
 * The verdicts on a plan.
 *
 * `null` when it could not be read, which is NOT the same as "he has ruled on
 * nothing": the caller holds off trusting the allowlist rather than routing a
 * plan against a vocabulary he has already overruled.
 */
export const fetchTrayVerdicts = async (
  floorPlanId: number,
): Promise<TrayVerdicts | null> => {
  try {
    const response = await authFetch(`${ENDPOINT}?floorPlanId=${floorPlanId}`);
    if (!response.ok) return null;
    const body = (await response.json()) as TrayVerdictRow[];
    if (!Array.isArray(body)) return null;
    const out: TrayVerdicts = {};
    for (const row of body) out[row.routeTypeId] = row.carriesCable;
    return out;
  } catch {
    return null;
  }
};

/** False when it could not be written, so the caller never shows a verdict the
 * router does not have. */
export const saveTrayVerdict = async (
  routeTypeId: number,
  carriesCable: boolean | null,
): Promise<boolean> => {
  try {
    const response = await authFetch(ENDPOINT, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ routeTypeId, carriesCable }),
    });
    return response.ok;
  } catch {
    return false;
  }
};
